"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../../common/helpers/queryString");
var CouponsModel = /** @class */ (function () {
    function CouponsModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/coupons",
            UPDATE: APPURL + "/api/v1/coupons",
            CREATE: APPURL + "/api/v1/coupons",
        };
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    CouponsModel.prototype.extract = function (result) {
        return result.data;
    };
    CouponsModel.prototype.cacheResults = function (result) {
        return this.extract(result);
    };
    CouponsModel.prototype.getByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    // The actual implementation (this is what gets called at runtime)
    CouponsModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        var url = this.URLS.FETCH;
        if (data !== null) {
            var payload = __assign(__assign({}, data), { valid: data.valid === true ? "1" : "0", paging: data.paging === true ? "1" : "0" });
            url = this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(payload);
        }
        return this.$http
            .get(url)
            .then(this.cacheResults);
    };
    CouponsModel.prototype.validateCoupon = function (code) {
        var url = this.URLS.FETCH;
        return this.$http
            .get(url + "/validate/" + code)
            .then(this.cacheResults);
    };
    CouponsModel.prototype.create = function (coupon) {
        return this.$http
            .post(this.URLS.FETCH, coupon)
            .then(this.cacheResults);
    };
    CouponsModel.prototype.update = function (request) {
        return this.$http
            .patch(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    CouponsModel.prototype.destroy = function (coupon) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + coupon.id)
            .then(this.cacheResults);
    };
    CouponsModel.prototype.getProducts = function (coupon) {
        return this.$http
            .get(this.URLS.FETCH + "/" + coupon.id + "/products")
            .then(this.cacheResults);
    };
    CouponsModel.prototype.addProduct = function (coupon, product) {
        return this.$http
            .post(this.URLS.FETCH + "/" + coupon.id + "/products", {
            product_id: product.id,
        })
            .then(this.cacheResults);
    };
    CouponsModel.prototype.removeProduct = function (coupon, product) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + coupon.id + "/products/" + product.id)
            .then(this.cacheResults);
    };
    return CouponsModel;
}());
CouponsModel.$inject = ["$http", "APPURL"];
exports.default = CouponsModel;
